import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
export const InstrumentRendererError = () => {
    return (_jsx(FlexBox, Object.assign({ flex: "1", justifyContent: "center", alignItems: "center" }, { children: _jsx(EmptyState, { title: "Something went wrong", description: "This data is currently unavailable due to an unexpected error. Our\n        team has been notified and is looking into the issue.", icon: "exclamation", iconColor: "red.500", buttonProps: {
                variant: 'primary',
                children: 'Try reloading',
                onClick: () => window.location.reload(),
            } }) })));
};
